
interface BaseButton {
  label: string
  onClick?: (p?: any) => void
  customClass?: string
  homeVariant?: boolean
  iconSrc?: string
}

export const BaseBtn = (props: BaseButton) => {
  const {label, onClick, customClass = '', homeVariant = false, iconSrc} = props

  return <button
      onClick={() => !!onClick ? onClick() : null}
      className={`
        w-full max-w-sm px-xl py-lg rounded-full bg-primary text-accent font-medium text-btn-main leading-5
        transition-colors duration-200 hover:opacity-90 focus-visible:outline-2 focus-visible:outline-accent focus-visible:-outline-offset-1 active:opacity-75 min-h-12
        ${
          !homeVariant
          ? 'mode-totem:max-w-[600px] mode-totem:h-[85px] mode-totem:rounded-[50px] mode-totem:text-2xl'
          : 'mode-totem:max-w-[50%] mode-totem:rounded-btn-nav mode-totem:leading-none mode-totem:py-7'
        }
        ${customClass}
      `}
    >
      <span className="flex items-center justify-center gap-2">
        {iconSrc && <img src={iconSrc} alt="" aria-hidden="true" className="w-5 h-5 mode-totem:w-8 mode-totem:h-8" />}
        {label}
      </span>
    </button>
}

        